import {Button, ButtonProps} from '@mui/material';
import React, {PropsWithChildren} from 'react';

import {StyledStack} from './styles';
import {RootProps} from './types';

function Root({children, $isTablet, ...stackProps}: PropsWithChildren<RootProps>) {
	return (
		<StyledStack $isTablet={$isTablet} {...stackProps}>
			{children}
		</StyledStack>
	);
}

function Action(props: ButtonProps) {
	return <Button {...props} />;
}

export const CTAButtonFixed = {
	Root,
	Action,
};
